import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { AddIcon, UserIcon } from 'components/Icons'
import { getClientEmployees, getCompanySupervisors } from 'services/clients.svc'
import { useParamountAuth } from 'context/ParamountAuthContext'
import './SupervisorList.scss'

export default function SupervisorList({ companyId, children }) {
  const { data: supervisors = [] } = useQuery(['companySupervisors', companyId], () =>
    getCompanySupervisors(companyId),
  )

  const { data: employees = [] } = useQuery(['clientEmployees', companyId], () =>
    getClientEmployees(companyId),
  )

  const admin = useMemo(
    () => employees.filter((e) => e.userRole?.role === 'CompanyAdmin'),
    [employees],
  )

  const sortedSupervisors = useMemo(
    () => [...supervisors].sort((a, b) => {
      const aAccepted = !!a.userRole?.termsAcceptedAt
      const bAccepted = !!b.userRole?.termsAcceptedAt
      return bAccepted - aAccepted
    }),
    [supervisors],
  )

  const { userRoles } = useParamountAuth()

  return (
    <div className="supervisor-list">
      <div>
        <h6>Admin</h6>
        {admin.map((employee) => (
          <Link
            to={`employees/${employee._id}`}
            key={employee._id}
            className="profile-svg"
          >
            <p>
              {employee.firstName} {employee.surname}
            </p>
            <UserIcon />
          </Link>
        ))}
      </div>
      <div>
        <h6>Site Supervisors</h6>
        {sortedSupervisors.length > 0 && (
          <div className="supervisor-row header">
            <span>Name</span>
            <span>Email</span>
            <span>Phone</span>
            <span />
          </div>
        )}
        {sortedSupervisors.map((employee) => {
          const hasAccepted = !!employee.userRole?.termsAcceptedAt
          return (
            <div key={employee._id} className={`supervisor-row ${hasAccepted ? 'supervisor-row--accepted' : 'supervisor-row--pending'}`}>
              <Link to={`employees/${employee._id}`} className="supervisor-name">
                {employee.firstName} {employee.surname}
              </Link>
              <span>{employee.contactEmail}</span>
              <span>{employee.phone}</span>
              <span />
            </div>
          )
        })}
        {!sortedSupervisors.length && <p className="no-supervisors">No supervisors added yet</p>}
      </div>
      <div>
        {userRoles[0] === 'CompanyAdmin' && (
          <Link className="contrast" to={'employees/add'} role="button">
            <AddIcon fill="var(--color-white)" />
            Add Site Supervisor
          </Link>
        )}
      </div>
      {children}
    </div>
  )
}
